export class CollectiveAgreementListDTO {

    id: string;

    name: string;

    description: string;

}
